// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__UxyiN","content":"ResetPassword_content__c2QMx","image":"ResetPassword_image__H+Hbm"};